import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { FraudBlock } from "../../../../types/fraud.types";
import { formatIsoToBrDate } from "../../../../utils/functions";
import { ActionsCell } from "../../../../components/Table";
import ViewBlockDetails from "../ViewBlockDetails/ViewBlockDetails";
import UnblockUser from "../UnblockUser/UnblockUser";

interface Props {
  block: FraudBlock;
}

/** Formata CPF bruto (11 dígitos) como "XXX.XXX.XXX-XX" */
function formatCpf(raw: string): string {
  const v = (raw ?? "").replace(/\D/g, "").substring(0, 11);
  if (v.length <= 3) return v;
  if (v.length <= 6) return `${v.substring(0, 3)}.${v.substring(3)}`;
  if (v.length <= 9) return `${v.substring(0, 3)}.${v.substring(3, 6)}.${v.substring(6)}`;
  return `${v.substring(0, 3)}.${v.substring(3, 6)}.${v.substring(6, 9)}-${v.substring(9)}`;
}

const BlockedUserRow: React.FC<Props> = ({ block }: Props) => {
  return (
    <TableRow
      key={block.id}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      hover
    >
      <TableCell component="th" scope="row" sx={{ whiteSpace: "nowrap" }}>
        {formatCpf(block.cpf)}
      </TableCell>
      <TableCell>{block.full_name || "—"}</TableCell>
      <TableCell>{block.email || "—"}</TableCell>
      <TableCell>{block.blockReason || "—"}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>{formatIsoToBrDate(block.date)}</TableCell>
      <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
        <ActionsCell style={{ justifyContent: "flex-end" }}>
          <ViewBlockDetails block={block} />
          <UnblockUser block={block} />
        </ActionsCell>
      </TableCell>
    </TableRow>
  );
};

export default BlockedUserRow;
